const allItems = [
  {
    _name: 'CSidebarNavItem',
    name: 'لوحة التحكم',
    to: '/dashboard',
    icon: 'cil-speedometer'
    // badge: {
    // }
  },
  {
    _name: 'CSidebarNavItem',
    name: 'الطلاب',
    to: '/students',
    icon: 'cil-speedometer'
    // badge: {
    // }
  },
  {
    _name: 'CSidebarNavItem',
    name: 'تسجيلات الطلاب',
    to: '/courses-students',
    icon: 'cil-speedometer'
    // badge: {
    // }
  },
  {
    _name: 'CSidebarNavItem',
    name: 'المدفوعات',
    to: '/payments',
    icon: 'cil-calculator'
    // badge: {
    // }
  },
  {
    _name: 'CSidebarNavItem',
    name: 'الشهادات',
    to: '/certificates',
    icon: 'cil-calculator',
    badge: {
    }
  },
  {
    _name: 'CSidebarNavItem',
    name: 'الدورات',
    to: '/courses',
    icon: 'cil-speedometer',
    badge: {
    }
  },
  // {
  //   _name: 'CSidebarNavItem',
  //   name: 'الوحدات',
  //   to: '/sections',
  //   icon: 'cil-speedometer',
  //   badge: {
  //   }
  // },
  // {
  //   _name: 'CSidebarNavItem',
  //   name: 'الدروس',
  //   to: '/lessons',
  //   icon: 'cil-speedometer',
  //   badge: {
  //   }
  // },
  {
    _name: 'CSidebarNavItem',
    name: 'المدربين',
    to: '/instructors',
    icon: 'cil-user'
    // badge: {
    // }
  },
  {
    _name: 'CSidebarNavDropdown',
    name: 'الأقسام',
    icon: 'cil-list',
    items: [
      {
        _name: 'CSidebarNavItem',
        name: 'الأقسام  الرئيسية ',
        to: '/categories',
        icon: 'cil-calculator',
        // _badge: {},
        // badge: {text: localStorage.categories,
        // color: 'warning',
        shape: 'pill',
        id: 'categories_badge'
      },
      {
        _name: 'CSidebarNavItem',
        name: ' الأقسام الفرعية ',
        to: '/sub-categories',
        icon: 'cil-chart-pie'
      }
    ]
  },
  {
    _name: 'CSidebarNavItem',
    name: 'أكواد الدعوة',
    to: '/referral-codes',
    icon: 'cil-speedometer'
    // badge: {
    // }
  },
  {
    _name: 'CSidebarNavItem',
    name: 'اعدادت الموقع',
    to: '/site-profile',
    icon: 'cil-calculator'
    // badge: {
    // }
  }

]

let userSidebar = []

if (localStorage.token) {
  userSidebar = allItems
} else {
  userSidebar = allItems
}

export default [
  {
    _name: 'CSidebarNav',
    _children: userSidebar
  }
]
